// VocabularyListScreen.js
import React, { useState, useEffect } from 'react';
import './styles/VocabularyListScreen.css';
import { toggleBookmark, getBookmarkedWords } from '../utils/storage';
import { useTranslation } from 'react-i18next';
import BackButton from '../components/BackButton';

import vocabulary_A1 from '../data/vocabulary_A1';
import vocabulary_A2 from '../data/vocabulary_A2';
import vocabulary_B1 from '../data/vocabulary_B1';
import vocabulary_B2 from '../data/vocabulary_B2';
import extra_vocabulary from '../data/extra_vocabulary';

const VocabularyListScreen = () => {
  const { i18n } = useTranslation();
  const getAns = (item) => (i18n.language !== 'en' && item[i18n.language]) || item.answer;
  const [searchQuery, setSearchQuery] = useState('');
  const [bookmarkedWords, setBookmarkedWords] = useState([]);
  const [showBookmarksOnly, setShowBookmarksOnly] = useState(false);

  const vocabularyData = [
    ...vocabulary_A1,
    ...vocabulary_A2,
    ...vocabulary_B1,
    ...vocabulary_B2,
    ...extra_vocabulary,
  ];

  useEffect(() => {
    setBookmarkedWords(getBookmarkedWords());
  }, []);

  const handleToggleBookmark = (wordId) => {
    const updated = toggleBookmark(wordId);
    setBookmarkedWords(updated);
  };

  let filteredVocabularyData = vocabularyData.filter(
    (item) =>
      String(item.question).trim().toLowerCase().includes(searchQuery.toLowerCase()) ||
      String(getAns(item)).trim().toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (showBookmarksOnly) {
    filteredVocabularyData = filteredVocabularyData.filter((item) =>
      bookmarkedWords.includes(item.id)
    );
  }

  const speakNow = (textToRead) => {
    const synth = window.speechSynthesis;
    synth.cancel();
    const utterance = new SpeechSynthesisUtterance(textToRead);
    utterance.lang = "fi-FI";
    synth.speak(utterance);
  };

  const renderItem = ({ item }) => (
    <div className="item">
      <div className="item-content">
        <div className="question">{item.question}
          <img
            src={require('../assets/images/voice-dark.png')}
            style={{ width: 30, height: 30, marginLeft: 5 }}
            className='voiceIcon'
            alt="Speak" onClick={() => speakNow(item.question)}
          />
        </div>
        <div className="answer">{getAns(item)}</div>
      </div>
      <button
        className="bookmark-btn"
        onClick={() => handleToggleBookmark(item.id)}
        title={bookmarkedWords.includes(item.id) ? 'Remove bookmark' : 'Add bookmark'}
      >
        {bookmarkedWords.includes(item.id) ? '★' : '☆'}
      </button>
    </div>
  );

  return (
    <div className="container">
      <BackButton to="/" label="Home" />
      <h1 className="title">Vocabulary List</h1>
      <div className="search-row">
        <input
          type="text"
          className="searchBar"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button
          className={`bookmark-filter-btn ${showBookmarksOnly ? 'active' : ''}`}
          onClick={() => setShowBookmarksOnly(!showBookmarksOnly)}
          title={showBookmarksOnly ? 'Show all words' : 'Show bookmarked only'}
        >
          {showBookmarksOnly ? '★ Bookmarked' : '☆ All'}
        </button>
      </div>
      <div className="itemDiv">
        {filteredVocabularyData.map((item, index) => (
          <div key={index}>{renderItem({ item })}</div>
        ))}
        {filteredVocabularyData.length === 0 && (
          <p className="no-results">No vocabulary found</p>
        )}
      </div>
    </div>
  );
};
export default VocabularyListScreen;
